import React, { useState, useEffect } from 'react'
import ReactPlayer from 'react-player'

function VideoSlideComponent(props) {
  const {
    mcData,
    isTtsPlay,
    timerEnd,
    onValueChange,
    isBgAudioPlayed,
    onVideoPlaying
  } = props
  const { ControlID, Url } = mcData
  const [playing, setPlaying] = useState(false)

  useEffect(() => {
    if (isTtsPlay) {
      setPlaying(false)
    }
  }, [isTtsPlay])

  useEffect(() => {
    if (timerEnd) {
      onValueChange(ControlID, '', 0, 0, '', true)
    }
  }, [timerEnd])

  useEffect(() => {
    onVideoPlaying(playing)
  }, [playing])

  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        height: '100%',
        backgroundColor: 'lightblue',
        justifyContent: 'center',
        borderRadius: '10px',
        padding: '15px'
      }}
    >
      <div
        style={{
          flex: 1,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <ReactPlayer
          url={Url}
          width='100%'
          height='100%'
          playing={playing}
          onPlay={() => {
            if (isBgAudioPlayed) {
              setPlaying(true)
            }
          }}
          onPause={() => {
            if (isBgAudioPlayed) {
              setPlaying(false)
            }
          }}
          onEnded={() => {
            if (isBgAudioPlayed) {
              setPlaying(false)
            }
          }}
          controls={true}
        />
      </div>
    </div>
  )
}

export default VideoSlideComponent
